import {
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AuthService } from '../../../auth/auth.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  templateUrl: './transactions-email-modal.component.html',
  providers: [
    AuthService
  ],
  preserveWhitespaces: true,
})
export class TransactionsEmailModalComponent implements OnInit {
  public loading = true;
  public error: string;
  public htmlData: any;

  constructor(
    public dialogRef: MatDialogRef<TransactionsEmailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.htmlData = null;
    this.error = null;
    this.loading = true;
    if (this.data.body && this.data.subject) {
        this.formatBody();
      this.sanitizeHtml();
    } else {
      this.error = 'Error loading email contents.';
    }
    this.loading = false;
  }

  closeDialog() {
    this.dialogRef.close();
  }

    formatBody() {
      this.data.body = this.data.body.replace(/\r\n|\r|\n|\p{Cc}/gimu, '<br>');
    }

  sanitizeHtml() {
    this.htmlData = this.sanitizer.bypassSecurityTrustHtml(this.data.body); // this line bypasses angular security
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/transactions/transactions-email-modal/transactions-email-modal.component.ts